import { apiHost, apiPort } from '../../../config'

export default class CSRFMiddleware {

  constructor() {

    if (global.GENEVA_CONFIG && global.GENEVA_CONFIG.csrfTokens) {
      this.loadCSRFTokens()
    }
    else {
      console.warn('csrf will not work properly, tokens missing')
    }

  }

  loadCSRFTokens() {
    const tokens = global.GENEVA_CONFIG.csrfTokens
    this.csrfTokens = Object.keys(tokens)
      .reduce((memo, domain) => {
        const token = tokens[domain]
        domain = this.getDomain(domain)
        return {
          ...memo,
          [domain]: token
        }
      }, {})
  }

  getDomain(url) {

    if (/^(https?:)?\/\//.test(url)) {

      return url
        // remove protocol
        .split('//')[1]
        // remove trailing path
        .split('/')[0]

    }

    const port = (apiPort && apiPort * 1 !== 80)
      ? `:${apiPort}`
      : ''

    // for relative urls
    return `${apiHost}${port}`

  }

  getToken(url) {

    const domain = this.getDomain(url)
    let token = this.csrfTokens[domain]

    // lazy load tokens if they are not present
    if (!token) {
      this.loadCSRFTokens()
      token = this.csrfTokens[domain]
    }

    return token

  }

  setCSRFToken(domain, token) {
    this.csrfTokens[domain] = token
  }

  request(opts) {

    const token = this.getToken(opts.url)

    if (!token) {
      return opts
    }

    return {
      ...opts,
      headers: {
        ...opts.headers,
        'X-CSRF-TOKEN': token
      }
    }

  }

  response({ res, err }) {

    if (err && err.status === 401) {

      // in case we get an unauthorized error, reset the csrf token
      this.setCSRFToken(
        this.getDomain(err.url),
        res.getResponseHeader('X_CSRF_TOKEN')
      )

    }

  }

}



// WEBPACK FOOTER //
// ./src/shared/api/middleware/csrf.js